// Discreet "Powered by MindWeavage" badge (secondary to WWW branding).
// Shown on all WWW screens EXCEPT the full-screen Wallpaper Player / Viewer.
// variant="dark" inverts the black artwork to white for dark surfaces.
export function PoweredBy({ variant = "light", className = "" }) {
  return (
    <span className={`ww-poweredby ww-poweredby-${variant} ${className}`}
          data-testid="powered-by-mindweavage" aria-label="Powered by MindWeavage">
      <img src="/brand/powered-by-mindweavage.png" alt="Powered by MindWeavage" loading="lazy" />
    </span>
  );
}
